import Base from "../../base";
import SideMenu from "../SideMenu";
import LeftMenu from "../../../components/LeftMenu";
import Header from "../Header";
import { useParams } from "react-router";
import { useEffect, useState } from "react";
import axiosConfig from "../../../services/Axios";
import Title from "../../../components/ui/Title";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBoxCircleCheck,
  faCloudUploadAlt,
  faDolly,
  faHandHoldingBox,
  faSplit,
  faTrashAlt,
} from "@fortawesome/pro-regular-svg-icons";
import {
  faBasketShopping,
  faLocationDot,
  faPersonDolly,
  faRepeat,
  faArrowLeftFromLine,
} from "@fortawesome/pro-duotone-svg-icons";
import OrderState from "../../../components/ui/OrderState";
import { Link } from "react-router-dom";
import SelectPartnerLogisticAddress from "../../../components/ui/Selects/PartnerLogisticAddress";
import ItemThumbs from "../../shop/ItemThumbs";
import { useSelector } from "react-redux";
import SelectOrderStates from "../../../components/ui/Selects/OrderStates";
import { toast } from "react-toastify";
import LabelCount from "../../../components/ui/LabelCount";
import Swal from "sweetalert2";
import EditQuantity from "./EditQuantity";
import useTailwindBreakpoint from "../../../hooks/useTailwindBreakpoint";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { removeBasket } from "../../../features/basket/basketSlice";

function OrderView() {
  const params = useParams();
  const [order, setOrder] = useState();
  const [hasMultiplePartner, setHasMultiplePartner] = useState(false);
  const authUser = useSelector((state) => state.auth);
  const dispatch = useDispatch();
  const [itemReceipt, setItemReceipt] = useState(
    order?.itemReceipt ? order.itemReceipt : false
  );
  const currentBp = useTailwindBreakpoint();
  let navigate = useNavigate();
  const { t } = useTranslation();

  const loadOrder = () => {
    axiosConfig
      .get(process.env.REACT_APP_API_URL + "/api/purchase_orders/" + params.id)
      .then((response) => {
        if (response?.status === 200 && response?.data) {
          setOrder(response.data);
          let partners = response.data.purchaseOrderItems.map(
            (poi) => poi.item.partner.id
          );
          let uniquePartners = [...new Set(partners)];
          setHasMultiplePartner(uniquePartners.length > 1);
        }
      });
  };
  useEffect(() => {
    loadOrder();
  }, []);

  const updateState = async (state) => {
    Swal.fire({
      text: t("settings.orders.changeStateQuestion", {
        previous_state: t("settings.orders.state." + order.state),
        state: t("settings.orders.state." + state),
      }),
      icon: "question",
      showCancelButton: true,
      confirmButtonText: t("global.btn.confirm_modify"),
      cancelButtonText: t("global.btn.cancel"),
      customClass: {
        actions: "gap-2 h-20",
      },
    }).then((result) => {
      if (result.isConfirmed) {
        try {
          axiosConfig
            .patch(
              process.env.REACT_APP_API_URL + order["@id"],
              { state },
              {
                headers: { "Content-Type": "application/merge-patch+json" },
              }
            )
            .then((response) => {
              if (response?.status === 200 && response?.data) {
                toast.success(t("settings.orders.updated"), {
                  theme: "colored",
                  hideProgressBar: true,
                });
                setOrder(response.data);
              }
            });
        } catch (e) {
          console.log(e);
        }
      }
    });
  };

  const updateDeliveryAddress = async (address) => {
    try {
      await axiosConfig
        .patch(
          process.env.REACT_APP_API_URL + order["@id"],
          { deliveryAddress: address },
          {
            headers: { "Content-Type": "application/merge-patch+json" },
          }
        )
        .then((response) => {
          if (response?.status === 200 && response?.data) {
            toast.success(t("settings.orders.updated"), {
              theme: "colored",
              hideProgressBar: true,
            });
            setOrder(response.data);
          }
        });
    } catch (e) {
      console.log(e);
    }
  };

  const handleSeparateOrder = (order) => {
    Swal.fire({
      text: t("settings.orders.separateQuestion"),
      icon: "question",
      showCancelButton: true,
      confirmButtonText: t("global.btn.yes"),
      cancelButtonText: t("global.btn.cancel"),
      customClass: {
        actions: "gap-2 h-20",
      },
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          await axiosConfig
            .post(
              process.env.REACT_APP_API_URL +
                "/api/purchase_orders/" +
                order.id +
                "/split",
              {
                headers: { "Content-Type": "application/ld+json" },
              }
            )
            .then((response) => {
              if (response?.status === 200 && response?.data) {
                navigate(`/settings/orders`);
              }
            });
        } catch (e) {
          console.log(e);
        }
      }
    });
  };

  const switchItemReceipt = (itemReceipt) => {
    Swal.fire({
      text: t("settings.orders.switchQuestion", {
        previous_itemReceipt:
          order.itemReceipt === true
            ? t("settings.orders.itemReceiptOn")
            : t("settings.orders.itemReceiptOff"),
        itemReceipt:
          itemReceipt === true
            ? t("settings.orders.itemReceiptOn")
            : t("settings.orders.itemReceiptOff"),
      }),
      icon: "question",
      showCancelButton: true,
      confirmButtonText: t("global.btn.yes"),
      cancelButtonText: t("global.btn.cancel"),
      customClass: {
        actions: "gap-2 h-20",
      },
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          await axiosConfig
            .patch(
              process.env.REACT_APP_API_URL + order["@id"],
              { itemReceipt: itemReceipt },
              {
                headers: { "Content-Type": "application/merge-patch+json" },
              }
            )
            .then((response) => {
              if (response?.status === 200 && response?.data) {
                toast.success(t("settings.orders.updated"), {
                  theme: "colored",
                  hideProgressBar: true,
                });
                setItemReceipt(response.data.itemReceipt);
                setOrder(response.data);
              }
            });
        } catch (e) {
          console.log(e);
        }
      }
    });
  };

  const cancel = (order) => {
    Swal.fire({
      text: t("settings.orders.confirm_remove_basket"),
      icon: "question",
      showCancelButton: true,
      confirmButtonText: t("global.btn.yes"),
      cancelButtonText: t("global.btn.cancel"),
      customClass: {
        actions: "gap-2 h-20",
      },
    }).then((result) => {
      if (result.isConfirmed) {
        dispatch(removeBasket({ basket: order["@id"] })).then((response) => {
          navigate("/settings/orders");
        });
      }
    });
  };


  const handleExportPurchasOrder = (order) => {
    const params = { purchaseOrder: order.id };

    let filename = "export-commande-" + order.pieceNumber;

    axiosConfig
      .post(
        process.env.REACT_APP_API_URL + "/api/purchase-orders/export",
        params,
        {
          responseType: "arraybuffer",
        }
      )
      .then(async (response) => {
        if (response.data) {
          let b = new Blob([response.data]);
          const url = window.URL.createObjectURL(b);
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", filename + ".csv");
          document.body.appendChild(link);
          link.click();
        }
      })
      .catch((error) => {
        console.error(error);
      });
  };

  return (
    <Base>
      <Header />
      <div className="py-16 container m-auto px-6 grid grid-cols-12">
        <div className="col-span-12 lg:col-span-3 xl:col-span-2">
          <LeftMenu menu={SideMenu} />
        </div>
        {order && (
          <div className="lg:ml-6 lg:p-8 lg:px-10 text-sm mt-10 lg:mt-0 col-span-12 lg:col-span-9 xl:col-span-10 lg:bg-white rounded-lg">
            {["sm", "md", "lg"].includes(currentBp) ? (
              <div>
                <Title
                  icon={faBasketShopping}
                  title={t("settings.orders.title", {
                    number: order.pieceNumber,
                  })}
                  otherAction={
                    authUser?.user?.roles.includes("ROLE_ADMIN") &&
                    order.state !== "ready" && order.state !== "shipped" && (
                      <button onClick={() => cancel(order)}>
                        <FontAwesomeIcon
                          icon={faTrashAlt}
                          title={t("global.form.delete")}
                          className="flex items-center text-bioport-orange"
                        />
                      </button>
                    )
                  }
                />
                {authUser?.user?.roles.includes("ROLE_ADMIN") &&
                  order.state !== "ready" && order.state !== "shipped" ? (
                    <div className="text-sm font-normal justify-between flex mb-6">
                      <SelectOrderStates
                        onChange={(e) => updateState(e)}
                        value={order.state}
                        className="w-60"
                      />
                      <OrderState
                        order={order}
                        className=" px-4 text-xs flex ml-4 items-center "
                      />
                    </div>
                  ) : (
                      <span className={`rounded ml-2 p-1 px-2 text-sm bg-gray-300 cursor-pointer hover:bg-bioport-blue hover:text-white`}>
                          <FontAwesomeIcon
                            icon={faBoxCircleCheck}
                            data-tip
                            data-for={`purchaseOrderShipped${purchaseOrder.id}`}
                            onClick={(e) => updateState(purchaseOrder, 'shipped')}
                          />
                      </span>
                  )}
              </div>
            ) : (
              <Title
                icon={faBasketShopping}
                title={t("settings.orders.title", {
                  number: order.pieceNumber,
                })}
                otherAction={
                  <>
                    <div className="text-sm font-normal mr-4 flex">
                      
                      {authUser?.user?.roles.includes("ROLE_ADMIN") &&
                      order.state !== "ready" && order.state !== "shipped" ? (
                        <>
                          <SelectOrderStates
                            onChange={(e) => updateState(e)}
                            value={order.state}
                            className="w-60"
                          />
                          <button onClick={() => cancel(order)}>
                            <FontAwesomeIcon
                              title={t("global.form.delete")}
                              icon={faTrashAlt}
                              className="text-bioport-orange flex items-center pl-4 text-lg"
                            />
                          </button>
                        </>
                      ) : (<>
                        <OrderState
                          order={order}
                          className=" px-4 py-2 text-xs flex ml-4 items-center"
                        />
                          {order.state !== "shipped" &&
                          <span className={`rounded ml-2 p-1 px-2 text-sm bg-gray-300 cursor-pointer hover:bg-bioport-blue hover:text-white`}>
                              <FontAwesomeIcon
                                icon={faBoxCircleCheck}
                                data-tip
                                data-for={`purchaseOrderShipped${order.id}`}
                                onClick={(e) => updateState('shipped')}
                              />
                          </span>}
                      </>)}

                      {authUser?.user?.roles.includes("ROLE_ADMIN") &&
                          <div 
                            onClick={() => handleExportPurchasOrder(order)} 
                            className="text-white bg-bioport-blue px-3 py-1 rounded ml-2 flex items-center justify-center cursor-pointer hover:bg-bioport-blue-light"
                          >
                            <FontAwesomeIcon icon={faCloudUploadAlt} className="mr-2" />
                            <span className="text-xs">{t("global.export")}</span>
                          </div>
                      }
                    </div>
                  </>
                }
              />
            )}
            {authUser?.user?.roles.includes("ROLE_ADMIN") && (
              <Title
                title={
                  order.itemReceipt
                    ? t("settings.orders.itemReceiptOn")
                    : t("settings.orders.itemReceiptOff")
                }
                className="mt-8"
                small={true}
                icon={order.itemReceipt ? faPersonDolly : faArrowLeftFromLine}
                button={
                  order.state === "awaiting" || order.state === "validated"
                    ? {
                        label: order.itemReceipt
                          ? t("settings.orders.itemReceiptOffShort")
                          : t("settings.orders.itemReceiptOnShort"),
                        fn: () => switchItemReceipt(!order.itemReceipt),
                        icon: (
                          <FontAwesomeIcon
                            icon={faRepeat}
                            className={`${order.itemReceipt && "rotate-180"}`}
                          />
                        ),
                      }
                    : null
                }
              />
            )}
            <Title
              icon={faHandHoldingBox}
              title={t("settings.orders.beneficiary", {
                beneficiary: order.partner.name,
              })}
              className="mt-8"
              small={true}
            />

            <Title
              icon={faLocationDot}
              title={t("settings.orders.deliveryAddress", {
                address:
                  order.deliveryAddress &&
                  order.deliveryAddress.address +
                    " - " +
                    order.deliveryAddress.zipcode +
                    " " +
                    order.deliveryAddress.city,
              })}
              className="mt-8"
              small={true}
            />
            {((authUser?.user?.roles.includes("ROLE_ADMIN") &&
              order.state !== "ready" && order.state !== "shipped") ||
              order.state === "awaiting") && (
              <div>
                <label>{t("settings.orders.changeDeliveryAddress")} :</label>

                <SelectPartnerLogisticAddress
                  onChange={updateDeliveryAddress}
                  className={"py-1"}
                  isClearable={authUser?.user?.roles.includes("ROLE_ADMIN")}
                  value={order.deliveryAddress && order.deliveryAddress["@id"]}
                  partner={order.partner["@id"]}
                />
              </div>
            )}

            <Title
              icon={faDolly}
              title={t("settings.orders.recap")}
              className="mt-8"
              small={true}
              button={
                authUser?.user?.roles.includes("ROLE_ADMIN") &&
                (order.state === "awaiting" || order.state === "validated") &&
                order.splitable
                  ? {
                      label: t("settings.orders.separate"),
                      fn: () => handleSeparateOrder(order),
                      icon: <FontAwesomeIcon icon={faSplit} />,
                    }
                  : null
              }
            />

            <div className="bg-bioport-blue-light grid grid-cols-12 text-white font-bold">
              <div className="col-span-9 px-4 p-3">
                {" "}
                {t("settings.orders.orderItems.itemLabel")}
              </div>
              <div className="col-span-3 px-4 p-3 text-center">
                {t("settings.orders.orderItems.itemQuantity")}
              </div>
            </div>

            {order.purchaseOrderItems.map((oi, k) => (
              <div key={k} className="grid grid-cols-12 border-b items-center">
                <div className="invisible lg:visible lg:col-span-2">
                  <div className="h-40 relative">
                    <ItemThumbs item={oi.item} height={40} />
                  </div>
                </div>

                <div className="col-span-9 lg:col-span-7 px-5 py-2">
                  <div className="font-bold mb-1">{oi.item.name}</div>

                  <div className="text-xs">{oi.item.description}</div>

                  {authUser?.user?.roles.includes("ROLE_ADMIN") && (
                    <div className="grid grid-cols-12 text-xs mt-3">
                      <div className="col-span-5 lg:col-span-4 font-bold py-1">
                        {t("settings.orders.donator")} :
                      </div>

                      <div className="col-span-7 lg:col-span-8 py-1">
                        <Link
                          className="hover:underline"
                          to={"/settings/partners/" + oi.item.partner.id}
                        >
                          {oi.item.partner.name.toUpperCase()}
                        </Link>
                      </div>

                      <div className="col-span-5 lg:col-span-4 py-1 font-bold">
                        {t("settings.orders.donator_address")} :
                      </div>

                      <div className="col-span-7 lg:col-span-8 py-1">
                        <p>{oi.item.logisticAddress?.address}</p>
                        {oi.item.logisticAddress?.addressComplement && (
                          <p>{oi.item.logisticAddress?.addressComplement}</p>
                        )}
                        <p>
                          {oi.item.logisticAddress?.zipcode} -{" "}
                          {oi.item.logisticAddress?.city}
                        </p>
                        <p>{oi.item.logisticAddress?.country?.toUpperCase()}</p>
                      </div>
                    </div>
                  )}
                </div>

                <div className="col-span-3 text-center">
                  {authUser?.user?.roles.includes("ROLE_ADMIN") &&
                  order.state === "awaiting" ? (
                    <EditQuantity orderItem={oi} />
                  ) : (
                    <LabelCount
                      count={oi.quantity}
                      defaultClass="bg-gray-300"
                      enabledClass="bg-bioport-blue text-white"
                    />
                  )}
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </Base>
  );
}

export default OrderView;
